/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { isNumericDependencies } from './dependenciesIsNumeric.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createHasNumericValue } from '../../factoriesAny.js';
export var hasNumericValueDependencies = {
  isNumericDependencies: isNumericDependencies,
  typedDependencies: typedDependencies,
  createHasNumericValue: createHasNumericValue
};